import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { GameView, GameLinkView, GmGameView } from '#src/interfaces/gameManager'

const useGamesStore = defineStore('gamesStore', () => {
  const gameLinks = ref<GameLinkView[]>([])
  const linkGames = computed<GmGameView[]>(() =>
    gameLinks.value.map((link) => link.installation).map((installation) => installation.game)
  )
  const games = ref<GameView[]>([])

  const activeGameIds = computed(() => gameLinks.value.map((link) => link.code))

  const setGames = (newGames: GameView[]) => {
    games.value = newGames
  }

  const setGameLinks = (newGameLinks: GameLinkView[]) => {
    gameLinks.value = newGameLinks
  }

  const getGameById = (gameId: number): GmGameView | undefined =>
    linkGames.value.find((game) => game.externalId === gameId)

  const getGameLinkByCode = (linkCode: string): GameLinkView | undefined =>
    gameLinks.value.find(({ code }) => linkCode === code)

  const getGameLinkByDisplayId = (gameDisplayId: string): GameLinkView | undefined =>
    gameLinks.value.find((gameLink) => gameLink.installation.game.displayId === gameDisplayId)

  const getGameLinkByGameId = (gameId: string): GameLinkView | undefined =>
    gameLinks.value.find((gameLink) => gameLink.installation.game.id === gameId)

  const isGameAvailable = (game?: GameLinkView) => {
    if (!game) return false

    const { code } = game
    const displayId = game.installation?.displayId
    const ids = activeGameIds.value

    return (!!code && ids.includes(code)) || (!!displayId && ids.includes(displayId))
  }

  return {
    games,
    activeGameIds,
    gameLinks,
    linkGames,
    setGames,
    setGameLinks,
    getGameById,
    getGameLinkByCode,
    getGameLinkByDisplayId,
    getGameLinkByGameId,
    isGameAvailable
  }
})

export { useGamesStore }
